<template>
  <footer class="footer">
    <transition name="fade-long">
      <div class="_logo" v-if="this.$route.name != 'Contacts'">
        <img :src="require('@/assets/img/footer-logo-new.svg')" alt="" />
      </div>
    </transition>
    <div class="_grid">
      <div class="_name">A. RESIDENCE (C) 2026</div>
      <div class="_menu-wrap">
        <div class="_menu">
          <router-link to="/contacts">Контакты</router-link>
          <router-link to="/documents">Проектная&nbsp;документация</router-link>
          <!-- <a href="">Проектная&nbsp;декларация</a> -->
          <span @click="activateTermsPopup"
            >Политика&nbsp;конфиденциальности</span
          >
          <a href="/presentation.pdf" target="_blank">Презентация о проекте</a>
          <a v-if="instUrl" :href="instUrl">Instagram</a>
          <a v-if="tgUrl" :href="tgUrl" target="_blank">Telegram</a>
        </div>
      </div>
      <div class="_buro">
        <span>A. RESIDENCE (C) 2026</span>
        Сайт (С)
        <a href="https://madeinburo.com" target="_blank">Made in Buro</a>
      </div>
    </div>
    <div class="_terms">
      Любая информация, представленная на данном сайте, носит исключительно
      информационный характер и ни при каких условиях<br />не является публичной
      офертой, определяемой положениями статьи 437 ГК РФ.
    </div>
  </footer>
</template>

<script>
export default {
  methods: {
    activateTermsPopup() {
      this.$store.dispatch("changeTermsPopupActive", true)
    },
  },
  computed: {
    instUrl() {
      return this.$store.getters.getContacts.instagram
    },
    tgUrl() {
      return this.$store.getters.getContacts.telegram
    },
  },
}
</script>
